import { atom } from "jotai";

type FormAtomTypeOptions = {
    disabled?: boolean;
    // Add more options as needed
};

const formAtom = atom<Record<string, FormAtomTypeOptions>>({});
export default formAtom;
